import React, { useMemo } from 'react';
import PageTitle from 'common/components/PageTitle';
import { ApiAdminV1RecommendationTemplateListApiArg } from 'store/generated/admin/templates';
import { useNavigate } from 'react-router-dom';
import { templatesApi } from '../api/recommendation-templates';
import { RecommendationType } from 'common/constants/RecommendationType';
import { FoundationsListTable } from './FoundationListTable';
import { PageHeader } from 'common/styles/page';

const FoundationsList = () => {
  const [triggerDelete] = templatesApi.useApiAdminV1RecommendationTemplateDestroyMutation();

  const navigate = useNavigate();
  const { teamRecommendations, isLoading, error } =
    templatesApi.useApiAdminV1RecommendationTemplateListQuery(
      {} as ApiAdminV1RecommendationTemplateListApiArg,
      {
        selectFromResult: res => ({
          teamRecommendations:
            res.data?.filter(x => x.type_of === RecommendationType.FOUNDATIONS) ?? [],
          isLoading: res.isLoading,
          error: res.error,
        }),
      }
    );

  const navigateToDetails = (foundationProjectId?: number) => {
    if (foundationProjectId) {
      navigate(
        `/settings/admin/recommendation-templates/foundations/details/${foundationProjectId}`,
        {
          state: [],
        }
      );
    } else {
      navigate(`/settings/admin/recommendation-templates/foundations/details/create`, {
        state: [],
      });
    }
  };

  const onItemDeleteConfirm = (id: number) => {
    triggerDelete({ id });
  };

  const foundationProjects = useMemo(() => {
    if (!teamRecommendations) return [];

    return teamRecommendations
      ?.slice()
      .sort((a, b) => a?.template?.title.localeCompare(b?.template?.title));
  }, [teamRecommendations]);

  return (
    <div data-testid="admin-foundations-page">
      <FoundationsListTable
        data-testid="admin-foundations-table"
        title="Foundation Templates"
        projects={foundationProjects}
        isLoading={isLoading}
        error={error}
        onItemDeleteConfirm={onItemDeleteConfirm}
        onItemClick={navigateToDetails}
        onAddClick={() => navigateToDetails(undefined)}
      />
    </div>
  );
};

export default FoundationsList;
